(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["RPECK-banners-with-text"] && !Shopify.designMode) return;
  try {
    
  const events = [
    'shopify:section:reorder',
    'shopify:section:deselect',
    'shopify:section:select',
    'shopify:section:unload',
    'shopify:section:load',
  ];
  
  const banner_with_text = () => {
    let headerOverlay = document.querySelector('.overlay');
    let pageAbout = document.querySelector('.page-about');
    let pageLookbook = document.querySelector('.page-lookbook');
    let breadCrumb = document.querySelector('.main-breadcrumb');
    let colorScheme = document.querySelector('.header-color-light');
    let colorSchemeDark = document.querySelector('.header-color-dark');
    let firstSection = document.querySelector("section:first-of-type")
  
    if (headerOverlay && firstblock.classList.contains('section-banner-with-text')) {
        if (colorScheme) {
            headerOverlay.classList.add('theme-dark');
            headerOverlay.classList.add('header-color-background-5');
            if (pageAbout || pageLookbook) {
                breadCrumb.classList.add('color-background-5');
            }
        }
  
        if (colorSchemeDark) {
            headerOverlay.classList.remove('theme-dark');
            headerOverlay.classList.remove('header-color-background-5');
            headerOverlay.classList.add('color-background-1');
            if (pageAbout || pageLookbook) {
                breadCrumb.classList.remove('color-background-5');
            }
        }
    } else {
        if (colorScheme) {
            if (pageAbout || pageLookbook) {
                breadCrumb.classList.add('color-background-5');
            }
        }
  
        if (colorSchemeDark) {
            if (pageAbout || pageLookbook) {
                breadCrumb.classList.remove('color-background-5');
            }
        }
    }
  };
  
  banner_with_text();
  
  events.forEach(function (item) {
    document.addEventListener(item, function () {
        banner_with_text();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["RPECK-perfect-gift"] && !Shopify.designMode) return;
  try {
    

  // RPECK 17/01/2024 - Check to see if all of the options are valid
  // --
  // Ref: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#supplying_request_options
  async function postData(url = "", data = {}) {
    
    // Default options are marked with *
    const response = await fetch(url);
    return response.text(); 
  }
  
  // RPECK 17/01/2024 - Attach a form submission event handler
  document.addEventListener('DOMContentLoaded', function(event){

    // RPECK 17/01/2024 - Vars
    var options_form = document.getElementById("options_form");

    // RPECK 17/01/2024 - Check if the options form is present
    if(options_form) {

      // RPECK 17/01/2024 - Bind the options form to a submit event
      options_form.addEventListener('submit', function(e){

        // RPECK 17/01/2024 - Stop the default process running
        e.preventDefault();

        // RPECK 17/01/2024 - Vars
        var form        = e.currentTarget; 
        var section     = document.querySelector('div.shopify-section.rpeck-perfect-gift');
        var options     = form.querySelectorAll('input[type="radio"]:checked');
        var productGrid = document.getElementById('ProductGridContainer');
        var base_url    = form.getAttribute('action');
        var tags        = [];
        var params      = {};

        // RPECK 27/01/2024 - Build out the various optioms we need to pass
        // There are 3 main option types - price, tag and filter/metafield
        // --
        // We need to cycle through the submitted data and get the correct tags to allocate to the URL
        options.forEach(function(option){

          // RPECK 27/01/2024 - Only proceed if the value is not empty
          if(option.value) {
            
            // RPECK 27/01/2024 - Get the parent container (allows us to infer the type)
            var parent = option.parentNode.parentNode;

            // RPECK 27/01/2024 - Check the type and populate the options array based on it 
            switch(parent.getAttribute('data-type')) {

              // RPECK 27/01/2024 - Product Tag
              // This needs to add extra items to the end of the URL pathname (EG /collections/all/test1+test2)
              case 'tag':

                // RPECK 27/01/2024 - Add the value to the "tags" array
                // This array will be joined to make the path used in the URL. We don't need to do this with the other values because they are all in the search params
                tags.push(option.value);

                // RPECK 27/01/2024 - Break out of the loop
                break;

              // RPECK 27/01/2024 - Price
              // This is added as a set of search params (filter.v.price.gte + filter.v.price.lte) 
              case 'price':

                // RPECK 27/01/2024 - Get the value and see if we can format it properly
                // First thing is to check if we need to break the value between two options - if more than one option is available, it means there is an upper limit
                if(option.value.includes('-')) {

                  // RPECK 27/01/2024 - Break apart the prices by the '-' symbol
                  // Limited to 2 values
                  var value = option.value.split('-', 2); 

                  // RPECK 27/01/2024 - Add the various price items based on the passed variables
                  if(value.length >= 1) params['filter.v.price.gte'] = value[0];
                  if(value.length >= 2) params['filter.v.price.lte'] = value[1];
                  
                } else {

                  // RPECK 27/01/2024 - No means there is only a lower limit
                  var value = option.value.replace(/[^0-9]/g,"");

                  // RPECK 27/01/2024 - Add the lower price value if it exists
                  if(value > 0) params['filter.v.price.gte'] = value;
                  
                }

                // RPECK 27/01/2024 - Break out of the loop
                break;   

              // RPECK 27/01/2024 - Metafield (Filter item)
              // This needs to add extra items to the end of the URL pathname (EG /collections/all/test1+test2)
              case 'metafield':

                // RPECK 27/01/2024 - Add the value to the "tags" array
                // This array will be joined to make the path used in the URL. We don't need to do this with the other values because they are all in the search params
                params[ option.name ] = option.value;

                // RPECK 27/01/2024 - Break out of the loop
                break;
                
            }
            
          }
          
        });

        // RPECK 27/01/2024 - Join the tags with plus symbols and append to base_url
        if(tags.length > 0) {
          base_url = base_url.concat("/", tags.join("+"));
        }

        // RPECK 17/01/2024 - URL
        // Create the required URL
        var url = new URL(base_url, document.location);

        // RPECK 27/01/2024- If the params array is populated, add each as a search param
        if(params && Object.keys(params).length > 0) { 
          
          Object.keys(params).forEach(function(key) {
            url.searchParams.append(key, params[key]); 
          });

        }

        // RPECK 28/01/2024 - Add 'loading' class to the main section (triggers the loading_overlay element)
        section.classList.add('loading');

        // RPECK 17/01/2024 - Get the filtered products
        postData(url.toString()).then((data) => {

          // RPECK 22/01/2024 - Check to see if the data starts with <section
          if(data) {

            // RPECK 27/01/2024 - Convert data to DOM object (allows us to call getElementById)
            // --
            // https://stackoverflow.com/a/3104237/1143732
            var html = new DOMParser().parseFromString(data, "text/html");

            // RPECK 27/01/2024 - Check if the html variable is populated
            if(html) {
              
              // RPECK 22/01/2024 - Get the product grid container
              var product_grid = html.getElementById('ProductGridContainer');
              
              // RPECK 27/01/2024 - If the product_grid variable is present, add it to the page
              if(product_grid && section) {

                // RPECK 27/01/2024 - Get the ProductGridContainer child element
                child = section.querySelector('#ProductGridContainer');
                
                if(child) {
                  
                  section.replaceChild(product_grid, child);

                } else {

                  section.appendChild(product_grid);
                  
                }

                // RPECK 28/01/2024 - Trigger 'loadMore' function
                if (typeof loadMore !== 'undefined' && typeof loadMore === 'function') {
                  loadMore();
                }

              }
              
            }
            
          }

          // RPECK 28/01/2024 - Remove 'loading' class to the main section (triggers the loading_overlay element)
          section.classList.remove('loading');

        });
        
      });
      
    }
    
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["RPECK-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  	class RecentlyViewed extends HTMLElement {
		constructor() {
			super();

            // RPECK 30/01/2024 - Populate the Recently Viewed cookie (array of product handles)
            var recently_viewed = [...new Set( this.getCookie('recently_viewed').split(",").filter(Boolean).slice(-4) )];

            const handleIntersection = (entries, observer) => {
              if (!entries[0].isIntersecting) return;
              observer.unobserve(this);

              // RPECK 30/01/2024 - Get the ul element
              const ul = this.querySelector('ul.product-recommendations__list');

              // RPECK 30/01/2024 - Recently Viewed section constant
              const section_id = window.recently_viewed_template; 

							console.log("recently viewed", ul, section_id, recently_viewed)

              // RPECK 27/02/2024 - Only proceed if the template is present
              if(section_id) {

                // RPECK 30/01/2024 - Array of promises
                // This is used to help us maintain the order of the requests (they were all finishing in different orders last time)
                // --
                // Ref: https://stackoverflow.com/a/77546983/1143732
                var urls = Promise.all(recently_viewed.map((handle) => this.fetchTodo("/products/" + handle + "?section_id=" + section_id)))
                  .then((items) => {
  
                    // RPECK 30/01/2024 - Loop through items and perform action on them
                    items.forEach(function(text) {
                      const html = document.createElement('div'); 
                      html.innerHTML = text;
                      const product = html.querySelector('.prd-Card');
      
                      if (product && product.innerHTML.trim().length) {
                        // RPECK 30/01/2024 - Create a new element for the list item
                        var list_item = document.createElement('li');
      
                        // RPECK 30/01/2024 - Add the various classes
                        list_item.classList.add('collection-product-card');
                        list_item.classList.add('product-recommendations__product');
                        list_item.classList.add('quickview--hover');
      
                        // RPECK 30/01/2024 - Append to the ul
                        list_item.appendChild(product);
                        ul.appendChild(list_item); 
                      }
                      
                    });
                    
                  }).catch((err) => console.error(err));
                
              }
            
            }

            // RPECK 30/01/2023 - Only trigger if recently_viewed is present
            if (recently_viewed) {

    			new IntersectionObserver(handleIntersection.bind(this), {
    				rootMargin: '0px 0px 200px 0px',
    			}).observe(this);

            }
		}

        /**
         * Get the value of a cookie
         * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
         * @param  {String} name  The name of the cookie
         * @return {String}       The cookie value
         */
        getCookie (name) {
          let value = `; ${document.cookie}`;
          let parts = value.split(`; ${name}=`);
          if (parts.length === 2) return parts.pop().split(';').shift();
        }

        // RPECK 30/01/2024 - Fetch
        async fetchTodo (url) {
          const res = await fetch(url);
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.text();
        };
      
	}

	customElements.define(
		'recently-viewed',
		RecentlyViewed
	);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-with-text"] && !Shopify.designMode) return;
  try {
    
  const events = [
    'shopify:section:reorder',
    'shopify:section:deselect',
    'shopify:section:select',
    'shopify:section:unload',
    'shopify:section:load',
  ];

  const banner_with_text = () => {
    let headerOverlay = document.querySelector('.overlay');
    let pageAbout = document.querySelector('.page-about');
    let pageLookbook = document.querySelector('.page-lookbook');
    let breadCrumb = document.querySelector('.main-breadcrumb');
    let colorScheme = document.querySelector('.header-color-light');
    let colorSchemeDark = document.querySelector('.header-color-dark');
    let firstSection = document.querySelector('section:first-of-type');

    if (headerOverlay && firstSection.classList.contains('section-banner-with-text')) {
      document.querySelector('main').classList.add('page-about');
      let pageAbout = document.querySelector('.page-about');
      let pageLookbook = document.querySelector('.page-lookbook');
      if (colorScheme) {
        headerOverlay.classList.add('theme-dark');
        headerOverlay.classList.add('header-color-background-5');
        if (pageAbout || pageLookbook) {
          breadCrumb.classList.add('color-background-5');
        }
      }

      if (colorSchemeDark) {
        headerOverlay.classList.remove('theme-dark');
        headerOverlay.classList.remove('header-color-background-5');
        headerOverlay.classList.add('color-background-1');
        if (pageAbout || pageLookbook) {
          breadCrumb.classList.remove('color-background-5');
        }
      }
    } else {
      if (colorScheme) {
        if (pageAbout || pageLookbook) {
          breadCrumb.classList.add('color-background-5');
        }
      }

      if (colorSchemeDark) {
        if (pageAbout || pageLookbook) {
          breadCrumb.classList.remove('color-background-5');
        }
      }
    }
  };

  banner_with_text();

  events.forEach(function (item) {
    ut;
    document.addEventListener(item, function () {
      banner_with_text();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}

		hide() {
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			//this.showActiveMedia();
			this.constProductPageSwiperCall();
		}
		showActiveMedia() {
			this.querySelectorAll(
				`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
					'data-media-id'
				)}"])`
			).forEach((element) => {
				element.classList.remove('active');
			});

			const activeMedia = this.querySelector(
				`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
			);
			const activeMediaTemplate = activeMedia.querySelector('template');
			const activeMediaContent = activeMediaTemplate
				? activeMediaTemplate.content
				: null;
			activeMedia.classList.add('active');

			activeMedia.scrollIntoView();

			if (
				activeMedia.nodeName == 'DEFERRED-MEDIA' &&
				activeMediaContent &&
				activeMediaContent.querySelector('.js-youtube')
			)
				activeMedia.loadContent();
		}

		constProductPageSwiperCall(showActiveMedia) {
			const activeMedia = this.querySelector(
				`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
			);
			let activeMediaIndex = 0;

			this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
				if (element == activeMedia) {
					activeMediaIndex = index;
				}
			});

			const prodPageSwiper = new Swiper('#product-page-swiper', {
				zoom: true,
				centeredSlides: false,
				slidesPerView: 1,
				autoheight: true,
				watchSlidesVisibility: false,
				watchSlidesProgress: true,
				observer: true,
				observeParents: true,
				init: false,
				navigation: {
					nextEl: '.swiper-button-next-prod-page',
					prevEl: '.swiper-button-prev-prod-page',
				},
				pagination: {
					el: '.swiper-pagination-product-page',
					clickable: true,
				},
				on: {
					click: function (e) {
						if (this.zoom.scale === 1) {
							this.zoom.in();
						} else {
							this.zoom.out();
						}
					},
				},
			});

			prodPageSwiper.on('init', function () {
				prodPageSwiper.slideTo(activeMediaIndex, 0, false);
			});
			prodPageSwiper.init();

			document
				.querySelector('.product-media-modal__toggle')
				.addEventListener('click', function () {
					prodPageSwiper.destroy();
				});
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const blog_header_overlay = () => {
		let headerOverlay = document.querySelector('.overlay');
		let colorScheme = document.querySelector('.header-color-light');

		if (headerOverlay) {
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
			} else {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	blog_header_overlay();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			blog_header_overlay();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const main_collection_banner = () => {
		let headerOverlay = document.querySelector('.overlay');
		let colorScheme = document.querySelector('.header-color-light');

		if (headerOverlay) {
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
			} else {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	main_collection_banner();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			main_collection_banner();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const account_header_overlay = () => {
		let headerOverlay = document.querySelector('.overlay');
		let colorScheme = document.querySelector('.header-color-light');

		if (headerOverlay) {
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
			} else {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	account_header_overlay();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			account_header_overlay();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-coming-soon"]) return;
  try {
    
		class ProductModal extends ModalDialog {
			constructor() {
				super();
			}

			hide() {
				super.hide();
				window.pauseAllMedia();
			}

			show(opener) {
				super.show(opener);
				//this.showActiveMedia();
				this.constProductPageSwiperCall()
			}
			showActiveMedia() {

				this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
						element.classList.remove('active');
					}
				)

				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				const activeMediaTemplate = activeMedia.querySelector('template');
				const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
				activeMedia.classList.add('active');

				activeMedia.scrollIntoView();

				if (
						activeMedia.nodeName == 'DEFERRED-MEDIA' &&
						activeMediaContent &&
						activeMediaContent.querySelector('.js-youtube')
					)
			activeMedia.loadContent();
			}

			constProductPageSwiperCall(showActiveMedia) {
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				let activeMediaIndex = 0

				this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
						if(element == activeMedia){
							activeMediaIndex = index
						}
					}
				)

				const prodPageSwiper = new Swiper("#product-page-swiper", {
					zoom: true,
					centeredSlides: false,
					slidesPerView: 1,
					autoheight: true,
					watchSlidesVisibility: false,
					watchSlidesProgress: true,
					observer: true,
					observeParents: true,
					init: false,
					navigation: {
						nextEl: ".swiper-button-next-prod-page",
						prevEl: ".swiper-button-prev-prod-page",
					},
					pagination: {
						el: ".swiper-pagination-product-page",
						clickable: true,
					},
					on: {
						click: function (e) {
								if (this.zoom.scale === 1) {
								this.zoom.in();
								} else {
									this.zoom.out();
								}
       			 },
					},
				});

				prodPageSwiper.on('init', function() {
					prodPageSwiper.slideTo(activeMediaIndex, 0, false);
				});
				prodPageSwiper.init()

				document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
			}
		}

		class ProductRecommendations extends HTMLElement {
			constructor() {
				super();

				const handleIntersection = (entries, observer) => {
					if (!entries[0].isIntersecting) return;
					observer.unobserve(this);

					fetch(this.dataset.url)
						.then(response => response.text())
						.then(text => {
							const html = document.createElement('div');
							html.innerHTML = text;
							const recommendations = html.querySelector('product-recommendations');
							if (recommendations && recommendations.innerHTML.trim().length) {
								this.innerHTML = recommendations.innerHTML;
							}
						})
						.catch(e => {
							console.error(e);
						});
				}

				new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
			}
		}

		customElements.define('product-modal', ProductModal);
		customElements.define('product-recommendations', ProductRecommendations);

  ////////////////////////////////
  ////////////////////////////////

  // RPECK 06/03/2024 - Catch the click event on the embroidery app
  var embroidery_elements = document.querySelectorAll('[id^="shopify-block-zepto_product_personalizer_product_personalizer_page"]');

  // RPECK 06/03/2024 - Cycle through the elements
  embroidery_elements.forEach(function(element) {

    // RPECK 06/03/2024 - Add a click event listener to the element
    element.addEventListener('click', function(event){
      event.target.classList.toggle('visible');
    });

  });

  ////////////////////////////////
  ////////////////////////////////

  const klarnaPlacement = () =>
  {
    const klarna_shadow_root = document.querySelector('klarna-placement')?.shadowRoot;
    const style_id = 'custom-style';

    if (klarna_shadow_root && !klarna_shadow_root.querySelector(`#${style_id}`))
    {
      const style_klarna = document.createElement('style');
      style_klarna.id = style_id;
      style_klarna.innerHTML = '.container {text-align: left; text-align: left; background: none; border: none; padding: 0;}';
      klarna_shadow_root.appendChild(style_klarna);
    }
  }

  setInterval(() => klarnaPlacement(), 100);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
			class ProductModal extends ModalDialog {
		  constructor() {
		    super();
		  }
		  hide() {
		    super.hide();
		    window.pauseAllMedia();
		  }
		  show(opener) {
		    super.show(opener);
		    //this.showActiveMedia();
		    this.constProductPageSwiperCall()
		  }
		  showActiveMedia() {
		    this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
		      element.classList.remove('active');
		    })
		    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		    const activeMediaTemplate = activeMedia.querySelector('template');
		    const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
		    activeMedia.classList.add('active');
		    activeMedia.scrollIntoView();
		    if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) activeMedia.loadContent();
		  }
		  constProductPageSwiperCall(showActiveMedia) {
		    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		    let activeMediaIndex = 0
		    this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
		      if (element == activeMedia) {
		        activeMediaIndex = index
		      }
		    })
		    const prodPageSwiper = new Swiper("#product-page-swiper", {
		      zoom: true,
		      centeredSlides: false,
		      slidesPerView: 1,
		      autoheight: true,
		      watchSlidesVisibility: false,
		      watchSlidesProgress: true,
		      observer: true,
		      observeParents: true,
		      init: false,
		      navigation: {
		        nextEl: ".swiper-button-next-prod-page",
		        prevEl: ".swiper-button-prev-prod-page",
		      },
		      pagination: {
		        el: ".swiper-pagination-product-page",
		        clickable: true,
		      },
		      on: {
		        click: function(e) {
		          if (this.zoom.scale === 1) {
		            this.zoom.in();
		          } else {
		            this.zoom.out();
		          }
		        },
		      },
		    });
		    prodPageSwiper.on('init', function() {
		      prodPageSwiper.slideTo(activeMediaIndex, 0, false);
		    });
		    prodPageSwiper.init()
		    document.querySelector('.product-media-modal__toggle').addEventListener("click", function() {
		      prodPageSwiper.destroy()
		    });
		  }
		}
		class ProductRecommendations extends HTMLElement {
		  constructor() {
		    super();
		    const handleIntersection = (entries, observer) => {
		      if (!entries[0].isIntersecting) return;
		      observer.unobserve(this);
		      fetch(this.dataset.url).then(response => response.text()).then(text => {
		        const html = document.createElement('div');
		        html.innerHTML = text;
		        const recommendations = html.querySelector('product-recommendations');
		        if (recommendations && recommendations.innerHTML.trim().length) {
		          this.innerHTML = recommendations.innerHTML;
		        }
		      }).catch(e => {
		        console.error(e);
		      });
		    }
		    new IntersectionObserver(handleIntersection.bind(this), {
		      rootMargin: '0px 0px 200px 0px'
		    }).observe(this);
		  }
		}
		customElements.define('product-modal', ProductModal);
		customElements.define('product-recommendations', ProductRecommendations);
		////////////////////////////////
		////////////////////////////////
		// RPECK 06/03/2024 - Catch the click event on the embroidery app
		var embroidery_elements = document.querySelectorAll('[id^="shopify-block-zepto_product_personalizer_product_personalizer_page"]');
		// RPECK 06/03/2024 - Cycle through the elements
		embroidery_elements.forEach(function(element) {
		  // RPECK 06/03/2024 - Add a click event listener to the element
		  element.addEventListener('click', function(event) {
		    event.target.classList.toggle('visible');
		  });
		});
		////////////////////////////////
		////////////////////////////////
		const klarnaPlacement = () => {
		  const klarna_shadow_root = document.querySelector('klarna-placement')?.shadowRoot;
		  const style_id = 'custom-style';
		  if (klarna_shadow_root && !klarna_shadow_root.querySelector(`#${style_id}`)) {
		    const style_klarna = document.createElement('style');
		    style_klarna.id = style_id;
		    style_klarna.innerHTML = '.container {text-align: left; text-align: left; background: none; border: none; padding: 0;}';
		    klarna_shadow_root.appendChild(style_klarna);
		  }
		}
		setInterval(() => klarnaPlacement(), 100);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const account_header_overlay = () => {
		let headerOverlay = document.querySelector('.overlay');
		let colorScheme = document.querySelector('.header-color-light');

		if (headerOverlay) {
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
			} else {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	account_header_overlay();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			account_header_overlay();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const banner_video = () => {
		let headerOverlay = document.querySelector('.overlay');
		let pageAbout = document.querySelector('.page-about');
		let pageLookbook = document.querySelector('.page-lookbook');
		let breadCrumb = document.querySelector('.main-breadcrumb');
		let colorScheme = document.querySelector('.header-color-light');
		let colorSchemeDark = document.querySelector('.header-color-dark');
		let firstSection = document.querySelector('section:first-of-type');

		if (
			headerOverlay &&
			firstSection.classList.contains('video-banner-section')
		) {
			document.querySelector('main').classList.add('page-about');
			let pageAbout = document.querySelector('.page-about');
			let pageLookbook = document.querySelector('.page-lookbook');
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
				if (pageAbout || pageLookbook) {
					breadCrumb.classList.add('color-background-5');
				}
			}

			if (colorSchemeDark) {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
				if (pageAbout || pageLookbook) {
					breadCrumb.classList.remove('color-background-5');
				}
			}
		} else {
			if (colorScheme) {
				if (pageAbout || pageLookbook) {
					breadCrumb.classList.add('color-background-5');
				}
			}

			if (colorSchemeDark) {
				if (pageAbout || pageLookbook) {
					breadCrumb.classList.remove('color-background-5');
				}
			}
		}
	};

	banner_video();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			banner_video();
		});
	});

  } catch(e) { console.error(e); }
})();
})();
